import PropTypes from 'prop-types';
import { useContext, Fragment } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';
import AmenitiesButton from './AmenitiesButton';
import { getIconMap } from './AmenitiesIconsMapping';

const Amenities = ({ amenities = [], isTravel = false, toAmenities }) => {
  const theme = useContext(ThemeContext);
  if (!amenities) return null;

  const amenitiesMostPopular = amenities.filter(
    (item) => item.type === 'Most Popular',
  );

  // hide amenities
  if (!isTravel || amenitiesMostPopular.length < 1) return null;

  const amenitiesButton = () => {
    const amenitiesFiltered = amenities.filter(
      (item) => item.type !== 'Most Popular',
    );

    if (
      amenitiesFiltered.length < 1 &&
      amenitiesMostPopular[0].amenitiesData.length <= 5
    )
      return null;

    return (
      <>
        <div className="amenities__button col-6 col-lg-4">
          <AmenitiesButton onClick={toAmenities} />
        </div>
        <style global jsx>
          {`
            .amenities__button {
              padding-top: 3px;
              padding-bottom: 3px;
            }
          `}
        </style>
      </>
    );
  };

  const renderItem = (item, index) => {
    if (index > 4) return null;

    return (
      <div className="amenities__item col-6 col-lg-4" key={item}>
        {getIconMap(item)}
        <span>{item}</span>
      </div>
    );
  };

  // Most Popular
  const renderList = (
    <>
      <div className="amenities__content row">
        {amenitiesMostPopular.map((data) => (
          <Fragment key={data.type}>
            {data.amenitiesData?.map((item, index) => {
              return renderItem(item, index);
            })}
          </Fragment>
        ))}
        {amenitiesButton()}
      </div>
      <style global jsx>
        {`
          .amenities__content {
            background: ${theme.commoncolors.greylighter};
            color: ${theme.colors.primary};
            font-size: 12px;
            line-height: 13px;
            margin: 0 -16px;
            padding: 5px;
          }
          .amenities__item {
            display: flex;
            padding-top: 3px;
            padding-bottom: 3px;
          }
          :global(.amenities__item .svg-inline--fa) {
            flex-shrink: 0;
            margin-right: 10px;
          }
          @media (min-width: ${theme.breakpoints.mdUp}) {
            .amenities__content {
              line-height: 19px;
              margin: 0 0 0 -16px;
            }
          }
          @media (min-width: ${theme.breakpoints.lgUp}) {
            .amenities__content {
              font-size: 20px;
              line-height: 22px;
              padding: 5px 5px 9px;
            }
          }
        `}
      </style>
    </>
  );

  return (
    <>
      <div className="amenities">{renderList}</div>
      <style jsx>
        {`
          .amenities {
            padding: 7px 0 8px;
          }
          @media (min-width: ${theme.breakpoints.smUp}) {
            .amenities {
              padding: 18px 0 24px;
            }
          }
        `}
      </style>
    </>
  );
};

Amenities.propTypes = {
  amenities: PropTypes.array,
  isTravel: PropTypes.bool,
  toAmenities: PropTypes.func.isRequired,
};

export default Amenities;
